import ex from "utils/ex";
import FocusableButton from "../FocusableButton";

export default function defaultRenderNextButtons(props) {
  const {
    page,
    onNPage,
    isFirst,
    isLast,
    initial,
    indicatorCount,
    halfCount,
    maxPage
  } = props || {};
  return (
    <FocusableButton
      {...ex(['PagingIndicatorButton', 'PaingIndicatorDirectionButton', 'PaingIndicatorPrevButton'], {
        disabled: isLast || maxPage < initial + indicatorCount,
        onClick: () => onNPage(Math.min(maxPage, page + indicatorCount)),
      })}
    >
      <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.3335 8.00004H12.6668M12.6668 8.00004L8.00016 3.33337M12.6668 8.00004L8.00016 12.6667" stroke="#1E1E1E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </FocusableButton>
  );
}